
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.PromptScalarFieldEnum = {
  id: 'id',
  content: 'content'
};

exports.Prisma.RelationLoadStrategy = {
  query: 'query',
  join: 'join'
};

exports.Prisma.CrispConversationScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  sessionId: 'sessionId',
  isEscalatedToCS: 'isEscalatedToCS',
  metadata: 'metadata',
  phone: 'phone',
  email: 'email'
};

exports.Prisma.CrispMessageScalarFieldEnum = {
  id: 'id',
  payload: 'payload',
  crispConversationId: 'crispConversationId',
  signature: 'signature',
  contentId: 'contentId',
  createdAt: 'createdAt'
};

exports.Prisma.ChatMessageScalarFieldEnum = {
  id: 'id',
  question: 'question',
  answer: 'answer',
  userId: 'userId',
  model: 'model',
  sourceIds: 'sourceIds',
  promptTokens: 'promptTokens',
  completionTokens: 'completionTokens',
  totalTokens: 'totalTokens',
  signature: 'signature',
  repliedAt: 'repliedAt',
  createdAt: 'createdAt',
  crispConversationId: 'crispConversationId',
  promptId: 'promptId'
};

exports.Prisma.DocumentScalarFieldEnum = {
  id: 'id',
  source: 'source',
  content: 'content',
  originalContent: 'originalContent',
  crispArticleID: 'crispArticleID',
  documentId: 'documentId',
  url: 'url',
  crispLastUpdatedAt: 'crispLastUpdatedAt',
  isLatest: 'isLatest',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserActionLogScalarFieldEnum = {
  id: 'id',
  questionKey: 'questionKey',
  selectedOption: 'selectedOption',
  parentMessageId: 'parentMessageId',
  crispConversationId: 'crispConversationId',
  createdAt: 'createdAt'
};

exports.Prisma.CommodityDocumentScalarFieldEnum = {
  id: 'id',
  category: 'category',
  recipient: 'recipient',
  country: 'country',
  region: 'region',
  maxDeclaredValue: 'maxDeclaredValue',
  maxUnitValue: 'maxUnitValue',
  missingInfoTypes: 'missingInfoTypes',
  purpose: 'purpose',
  content: 'content',
  messageType: 'messageType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isLatest: 'isLatest'
};

exports.Prisma.CommodityCheckLogScalarFieldEnum = {
  id: 'id',
  commodities: 'commodities',
  categories: 'categories',
  country: 'country',
  region: 'region',
  categoryDocumentIds: 'categoryDocumentIds',
  recipientDocumentIds: 'recipientDocumentIds',
  countryDocumentIds: 'countryDocumentIds',
  regionDocumentIds: 'regionDocumentIds',
  model: 'model',
  promptTokens: 'promptTokens',
  completionTokens: 'completionTokens',
  totalTokens: 'totalTokens',
  createdAt: 'createdAt'
};

exports.Prisma.CacheScalarFieldEnum = {
  key: 'key',
  value: 'value',
  type: 'type',
  ttl: 'ttl',
  createdAt: 'createdAt'
};

exports.Prisma.ChatEvaluationQuestionScalarFieldEnum = {
  id: 'id',
  question: 'question',
  expectedAnswer: 'expectedAnswer',
  createdAt: 'createdAt'
};

exports.Prisma.ChatEvaluationScalarFieldEnum = {
  id: 'id',
  question: 'question',
  answer: 'answer',
  sourceIds: 'sourceIds',
  sources: 'sources',
  answerTokens: 'answerTokens',
  metric: 'metric',
  evaluation: 'evaluation',
  evaluationTokens: 'evaluationTokens',
  model: 'model',
  score: 'score',
  createdAt: 'createdAt',
  evaluationRunId: 'evaluationRunId'
};

exports.Prisma.ChatEvaluationRunScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt'
};

exports.Prisma.ShopifyCustomAppScalarFieldEnum = {
  shop: 'shop',
  apiKey: 'apiKey',
  apiSecret: 'apiSecret',
  userID: 'userID',
  userEmail: 'userEmail',
  installLink: 'installLink',
  notifiedUser: 'notifiedUser',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ShopifySessionScalarFieldEnum = {
  id: 'id',
  shop: 'shop',
  state: 'state',
  isOnline: 'isOnline',
  accessToken: 'accessToken',
  scope: 'scope',
  userID: 'userID',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ShopifyWebhookScalarFieldEnum = {
  id: 'id',
  shop: 'shop',
  payload: 'payload',
  topic: 'topic',
  createdAt: 'createdAt',
  processedAt: 'processedAt'
};

exports.Prisma.ShopifyOrderScalarFieldEnum = {
  adminGraphqlApiId: 'adminGraphqlApiId',
  legacyResourceId: 'legacyResourceId',
  storeId: 'storeId',
  payload: 'payload',
  draft: 'draft',
  JustShipShippingID: 'JustShipShippingID',
  trackingNumber: 'trackingNumber',
  draftShipmentId: 'draftShipmentId',
  processedAt: 'processedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.EcommerceStoreScalarFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  platform: 'platform',
  createdAt: 'createdAt'
};

exports.Prisma.EcommerceStoreSettingScalarFieldEnum = {
  storeId: 'storeId',
  defaultBox: 'defaultBox',
  defaultItemCategory: 'defaultItemCategory',
  defaultItemWeight: 'defaultItemWeight',
  customsDescriptions: 'customsDescriptions',
  defaultShippingMethod: 'defaultShippingMethod',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EcommerceStoreSyncScalarFieldEnum = {
  storeId: 'storeId',
  isEnabled: 'isEnabled',
  initSyncStatus: 'initSyncStatus',
  lastSyncedAt: 'lastSyncedAt'
};

exports.Prisma.EcommerceTaxNumberScalarFieldEnum = {
  id: 'id',
  userID: 'userID',
  type: 'type',
  number: 'number',
  status: 'status',
  rejectionReason: 'rejectionReason',
  approvedAt: 'approvedAt',
  rejectedAt: 'rejectedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DraftShipmentScalarFieldEnum = {
  id: 'id',
  draftID: 'draftID',
  userID: 'userID',
  draft: 'draft',
  shippingID: 'shippingID',
  source: 'source',
  externalOrderId: 'externalOrderId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.BackgroundJobScalarFieldEnum = {
  id: 'id',
  name: 'name',
  payload: 'payload',
  result: 'result',
  status: 'status',
  attempts: 'attempts',
  created_at: 'created_at',
  updated_at: 'updated_at',
  last_error: 'last_error',
  run_at: 'run_at',
  failed_at: 'failed_at',
  locked_at: 'locked_at'
};

exports.Prisma.FreightCostInvoiceScalarFieldEnum = {
  id: 'id',
  shippingProvider: 'shippingProvider',
  trackingNumber: 'trackingNumber',
  invoiceNumber: 'invoiceNumber',
  totalAmount: 'totalAmount',
  costBreakdown: 'costBreakdown',
  dimensions: 'dimensions',
  actualWeights: 'actualWeights',
  ratedWeights: 'ratedWeights',
  shipperCountry: 'shipperCountry',
  recipientCountry: 'recipientCountry',
  shipperReference: 'shipperReference',
  invoiceDate: 'invoiceDate'
};

exports.Prisma.DutiesTaxesCostInvoiceScalarFieldEnum = {
  id: 'id',
  shippingProvider: 'shippingProvider',
  trackingNumber: 'trackingNumber',
  invoiceNumber: 'invoiceNumber',
  ratedWeights: 'ratedWeights',
  totalAmount: 'totalAmount',
  costBreakdown: 'costBreakdown',
  shipperCountry: 'shipperCountry',
  recipientCountry: 'recipientCountry',
  shipperReference: 'shipperReference',
  invoiceDate: 'invoiceDate'
};

exports.Prisma.WjQ_sfa_box_sizeScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  box_name: 'box_name',
  box_width: 'box_width',
  box_height: 'box_height',
  box_length: 'box_length',
  box_weight: 'box_weight'
};

exports.Prisma.WjQ_sfa_recipient_adressScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  full_name: 'full_name',
  email: 'email',
  country_code: 'country_code',
  subscriber_number: 'subscriber_number',
  address1: 'address1',
  address2: 'address2',
  address: 'address',
  country: 'country',
  city: 'city',
  state: 'state',
  zip: 'zip',
  prim_address: 'prim_address'
};

exports.Prisma.WjQ_sfa_sender_adressScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  address: 'address',
  country: 'country',
  unit: 'unit',
  zip: 'zip'
};

exports.Prisma.WjQ_usermetaScalarFieldEnum = {
  umeta_id: 'umeta_id',
  user_id: 'user_id',
  meta_key: 'meta_key',
  meta_value: 'meta_value'
};

exports.Prisma.WjQ_usersScalarFieldEnum = {
  ID: 'ID',
  external_id: 'external_id',
  external_auth_provider: 'external_auth_provider',
  user_login: 'user_login',
  user_pass: 'user_pass',
  user_nicename: 'user_nicename',
  user_email: 'user_email',
  user_url: 'user_url',
  user_registered: 'user_registered',
  user_activation_key: 'user_activation_key',
  user_key_expiry: 'user_key_expiry',
  user_status: 'user_status',
  display_name: 'display_name',
  on_next_scheme: 'on_next_scheme',
  stripe_customer_id: 'stripe_customer_id'
};

exports.Prisma.Preferential_ratesScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  min_weight: 'min_weight',
  max_weight: 'max_weight',
  rate: 'rate',
  user_notified: 'user_notified',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.User_segment_form_responseScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  completion_timestamp: 'completion_timestamp',
  form_data: 'form_data'
};

exports.Prisma.User_tnc_acceptanceScalarFieldEnum = {
  id: 'id',
  user_email: 'user_email',
  auth_provider: 'auth_provider',
  tnc_version: 'tnc_version',
  accepted_at: 'accepted_at',
  ip_address: 'ip_address',
  user_agent: 'user_agent'
};

exports.Prisma.Billing_credit_noteScalarFieldEnum = {
  creditNoteID: 'creditNoteID',
  associatedInvoiceID: 'associatedInvoiceID',
  shippingID: 'shippingID',
  customerName: 'customerName',
  customerEmail: 'customerEmail',
  recipientName: 'recipientName',
  recipientAddress: 'recipientAddress',
  creditNoteDate: 'creditNoteDate',
  gstRate: 'gstRate',
  gstTotal: 'gstTotal',
  totalAmount: 'totalAmount',
  reason: 'reason',
  createdTimestamp: 'createdTimestamp',
  updatedTimestamp: 'updatedTimestamp'
};

exports.Prisma.Billing_credit_note_line_itemScalarFieldEnum = {
  lineItemID: 'lineItemID',
  creditNoteID: 'creditNoteID',
  description: 'description',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  subtotal: 'subtotal',
  createdTimestamp: 'createdTimestamp',
  updatedTimestamp: 'updatedTimestamp'
};

exports.Prisma.Billing_invoiceScalarFieldEnum = {
  invoiceID: 'invoiceID',
  associatedInvoiceID: 'associatedInvoiceID',
  shippingID: 'shippingID',
  customerName: 'customerName',
  customerEmail: 'customerEmail',
  recipientName: 'recipientName',
  recipientAddress: 'recipientAddress',
  invoiceDate: 'invoiceDate',
  gstRate: 'gstRate',
  gstTotal: 'gstTotal',
  totalAmount: 'totalAmount',
  status: 'status',
  createdTimestamp: 'createdTimestamp',
  updatedTimestamp: 'updatedTimestamp'
};

exports.Prisma.Billing_invoice_line_itemScalarFieldEnum = {
  lineItemID: 'lineItemID',
  invoiceID: 'invoiceID',
  description: 'description',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  subtotal: 'subtotal',
  createdTimestamp: 'createdTimestamp',
  updatedTimestamp: 'updatedTimestamp'
};

exports.Prisma.Billing_payment_recordsScalarFieldEnum = {
  paymentID: 'paymentID',
  associatedDocumentID: 'associatedDocumentID',
  shippingID: 'shippingID',
  paymentType: 'paymentType',
  isInflow: 'isInflow',
  paymentDate: 'paymentDate',
  paymentAmount: 'paymentAmount',
  additionalPaymentSurcharge: 'additionalPaymentSurcharge',
  paymentMethod: 'paymentMethod',
  paymentReference: 'paymentReference',
  remarks: 'remarks',
  createdTimestamp: 'createdTimestamp',
  updatedTimestamp: 'updatedTimestamp'
};

exports.Prisma.CartitemdataScalarFieldEnum = {
  serialNo: 'serialNo',
  packageID: 'packageID',
  itemIX: 'itemIX',
  itemCategory: 'itemCategory',
  itemQuantity: 'itemQuantity',
  itemDescription: 'itemDescription',
  itemPrice: 'itemPrice',
  itemWeight: 'itemWeight',
  itemTotalPrice: 'itemTotalPrice',
  itemTotalWeight: 'itemTotalWeight',
  itemID: 'itemID',
  unapportionedWt: 'unapportionedWt',
  isFragile: 'isFragile'
};

exports.Prisma.CartparceldataScalarFieldEnum = {
  packageID: 'packageID',
  shippingID: 'shippingID',
  parcelIX: 'parcelIX',
  boxName: 'boxName',
  packingOrNotButton: 'packingOrNotButton',
  fragilePackingServiceButton: 'fragilePackingServiceButton',
  regularPackingCost: 'regularPackingCost',
  fragilePackingCost: 'fragilePackingCost',
  parcelLength: 'parcelLength',
  parcelWidth: 'parcelWidth',
  parcelHeight: 'parcelHeight',
  parcelWeight: 'parcelWeight',
  calculatedWeight: 'calculatedWeight',
  parcelSummItemWeight: 'parcelSummItemWeight',
  parcelDeclaredValue: 'parcelDeclaredValue',
  parcelInsuranceAmount: 'parcelInsuranceAmount',
  parcelQuote: 'parcelQuote',
  itemCount: 'itemCount',
  ruralSurcharge: 'ruralSurcharge'
};

exports.Prisma.CartrecipientdataScalarFieldEnum = {
  shippingID: 'shippingID',
  submissionID: 'submissionID',
  recName: 'recName',
  recEmail: 'recEmail',
  recPhoneNo: 'recPhoneNo',
  recCountry: 'recCountry',
  recAddress1: 'recAddress1',
  recAddress2: 'recAddress2',
  recAddress3: 'recAddress3',
  recCity: 'recCity',
  recState: 'recState',
  recZipCode: 'recZipCode',
  shippingPurpose: 'shippingPurpose',
  directSignature: 'directSignature',
  insuranceButton: 'insuranceButton',
  totalInsuredAmt: 'totalInsuredAmt',
  totalIndivRecParcels: 'totalIndivRecParcels',
  totalIndivRecCost: 'totalIndivRecCost',
  initialFreightQuote: 'initialFreightQuote',
  verifiedFreightQuote: 'verifiedFreightQuote',
  initialValentinesAmount: 'initialValentinesAmount',
  currencyCode: 'currencyCode',
  customValue: 'customValue',
  ruralSurcharge: 'ruralSurcharge',
  DutiesPaidBy: 'DutiesPaidBy',
  ImportDutyCharge: 'ImportDutyCharge',
  ImportTaxCharge: 'ImportTaxCharge',
  DutyHandlingFee: 'DutyHandlingFee',
  TotalDutiesAndTaxes: 'TotalDutiesAndTaxes',
  shopifyOrderID: 'shopifyOrderID',
  shippingMethod: 'shippingMethod'
};

exports.Prisma.CartsenderdataScalarFieldEnum = {
  submissionID: 'submissionID',
  submissionDateTime: 'submissionDateTime',
  senderFirstName: 'senderFirstName',
  senderLastName: 'senderLastName',
  senderEmail: 'senderEmail',
  senderPhoneNo: 'senderPhoneNo',
  dropoffPickupButton: 'dropoffPickupButton',
  dropoffDate: 'dropoffDate',
  dropoffTime: 'dropoffTime',
  pickupDate: 'pickupDate',
  pickupTime: 'pickupTime',
  pickupCountry: 'pickupCountry',
  pickupPostalCode: 'pickupPostalCode',
  pickupAddress: 'pickupAddress',
  pickupUnitNo: 'pickupUnitNo',
  totalNoOfParcels: 'totalNoOfParcels',
  totalNoOfRecipients: 'totalNoOfRecipients',
  totalAmount: 'totalAmount',
  TnC: 'TnC',
  timeSt: 'timeSt',
  addInfo: 'addInfo',
  pickupContactNo: 'pickupContactNo',
  b2b: 'b2b',
  user_id: 'user_id',
  isRemoved: 'isRemoved',
  orderID: 'orderID',
  updatedAt: 'updatedAt'
};

exports.Prisma.Crisp_whatsapp_business_callback_responsesScalarFieldEnum = {
  id: 'id',
  request_id: 'request_id',
  error: 'error',
  reason: 'reason',
  crisp_fingerprint: 'crisp_fingerprint',
  whatsapp_message_id: 'whatsapp_message_id',
  session_id: 'session_id',
  error_message: 'error_message',
  response_timestamp: 'response_timestamp'
};

exports.Prisma.Crisp_whatsapp_business_requestsScalarFieldEnum = {
  id: 'id',
  request_id: 'request_id',
  request_type: 'request_type',
  message_template_name: 'message_template_name',
  request_timestamp: 'request_timestamp',
  internal_id: 'internal_id'
};

exports.Prisma.Daily_pickup_stateScalarFieldEnum = {
  id: 'id',
  pickup_date: 'pickup_date',
  pickup_state: 'pickup_state'
};

exports.Prisma.Disc_prices_orig_users_above_50kg_v2ScalarFieldEnum = {
  Country: 'Country',
  code: 'code',
  weight_50_5kg: 'weight_50_5kg',
  weight_51kg: 'weight_51kg',
  weight_51_5kg: 'weight_51_5kg',
  weight_52kg: 'weight_52kg',
  weight_52_5kg: 'weight_52_5kg',
  weight_53kg: 'weight_53kg',
  weight_53_5kg: 'weight_53_5kg',
  weight_54kg: 'weight_54kg',
  weight_54_5kg: 'weight_54_5kg',
  weight_55kg: 'weight_55kg',
  weight_55_5kg: 'weight_55_5kg',
  weight_56kg: 'weight_56kg',
  weight_56_5kg: 'weight_56_5kg',
  weight_57kg: 'weight_57kg',
  weight_57_5kg: 'weight_57_5kg',
  weight_58kg: 'weight_58kg',
  weight_58_5kg: 'weight_58_5kg',
  weight_59kg: 'weight_59kg',
  weight_59_5kg: 'weight_59_5kg',
  weight_60kg: 'weight_60kg',
  weight_60_5kg: 'weight_60_5kg',
  weight_61kg: 'weight_61kg',
  weight_61_5kg: 'weight_61_5kg',
  weight_62kg: 'weight_62kg',
  weight_62_5kg: 'weight_62_5kg',
  weight_63kg: 'weight_63kg',
  weight_63_5kg: 'weight_63_5kg',
  weight_64kg: 'weight_64kg',
  weight_64_5kg: 'weight_64_5kg',
  weight_65kg: 'weight_65kg',
  weight_65_5kg: 'weight_65_5kg',
  weight_66kg: 'weight_66kg',
  weight_66_5kg: 'weight_66_5kg',
  weight_67kg: 'weight_67kg',
  weight_67_5kg: 'weight_67_5kg',
  weight_68kg: 'weight_68kg',
  weight_68_5kg: 'weight_68_5kg',
  weight_69kg: 'weight_69kg',
  weight_69_5kg: 'weight_69_5kg',
  weight_70kg: 'weight_70kg',
  weight_70_5kg: 'weight_70_5kg',
  weight_71kg: 'weight_71kg',
  weight_71_5kg: 'weight_71_5kg',
  weight_72kg: 'weight_72kg',
  weight_72_5kg: 'weight_72_5kg',
  weight_73kg: 'weight_73kg',
  weight_73_5kg: 'weight_73_5kg',
  weight_74kg: 'weight_74kg',
  weight_74_5kg: 'weight_74_5kg',
  weight_75kg: 'weight_75kg',
  weight_75_5kg: 'weight_75_5kg',
  weight_76kg: 'weight_76kg',
  weight_76_5kg: 'weight_76_5kg',
  weight_77kg: 'weight_77kg',
  weight_77_5kg: 'weight_77_5kg',
  weight_78kg: 'weight_78kg',
  weight_78_5kg: 'weight_78_5kg',
  weight_79kg: 'weight_79kg',
  weight_79_5kg: 'weight_79_5kg',
  weight_80kg: 'weight_80kg',
  weight_80_5kg: 'weight_80_5kg',
  weight_81kg: 'weight_81kg',
  weight_81_5kg: 'weight_81_5kg',
  weight_82kg: 'weight_82kg',
  weight_82_5kg: 'weight_82_5kg',
  weight_83kg: 'weight_83kg',
  weight_83_5kg: 'weight_83_5kg',
  weight_84kg: 'weight_84kg',
  weight_84_5kg: 'weight_84_5kg',
  weight_85kg: 'weight_85kg',
  weight_85_5kg: 'weight_85_5kg',
  weight_86kg: 'weight_86kg',
  weight_86_5kg: 'weight_86_5kg',
  weight_87kg: 'weight_87kg',
  weight_87_5kg: 'weight_87_5kg',
  weight_88kg: 'weight_88kg',
  weight_88_5kg: 'weight_88_5kg',
  weight_89kg: 'weight_89kg',
  weight_89_5kg: 'weight_89_5kg',
  weight_90kg: 'weight_90kg',
  weight_90_5kg: 'weight_90_5kg',
  weight_91kg: 'weight_91kg',
  weight_91_5kg: 'weight_91_5kg',
  weight_92kg: 'weight_92kg',
  weight_92_5kg: 'weight_92_5kg',
  weight_93kg: 'weight_93kg',
  weight_93_5kg: 'weight_93_5kg',
  weight_94kg: 'weight_94kg',
  weight_94_5kg: 'weight_94_5kg',
  weight_95kg: 'weight_95kg',
  weight_95_5kg: 'weight_95_5kg',
  weight_96kg: 'weight_96kg',
  weight_96_5kg: 'weight_96_5kg',
  weight_97kg: 'weight_97kg',
  weight_97_5kg: 'weight_97_5kg',
  weight_98kg: 'weight_98kg',
  weight_98_5kg: 'weight_98_5kg',
  weight_99kg: 'weight_99kg',
  weight_99_5kg: 'weight_99_5kg',
  weight_100kg: 'weight_100kg',
  weight_100_5kg: 'weight_100_5kg',
  weight_101kg: 'weight_101kg',
  weight_101_5kg: 'weight_101_5kg',
  weight_102kg: 'weight_102kg',
  weight_102_5kg: 'weight_102_5kg',
  weight_103kg: 'weight_103kg',
  weight_103_5kg: 'weight_103_5kg',
  weight_104kg: 'weight_104kg',
  weight_104_5kg: 'weight_104_5kg',
  weight_105kg: 'weight_105kg',
  weight_105_5kg: 'weight_105_5kg',
  weight_106kg: 'weight_106kg',
  weight_106_5kg: 'weight_106_5kg',
  weight_107kg: 'weight_107kg',
  weight_107_5kg: 'weight_107_5kg',
  weight_108kg: 'weight_108kg',
  weight_108_5kg: 'weight_108_5kg',
  weight_109kg: 'weight_109kg',
  weight_109_5kg: 'weight_109_5kg',
  weight_110kg: 'weight_110kg',
  weight_110_5kg: 'weight_110_5kg',
  weight_111kg: 'weight_111kg',
  weight_111_5kg: 'weight_111_5kg',
  weight_112kg: 'weight_112kg',
  weight_112_5kg: 'weight_112_5kg',
  weight_113kg: 'weight_113kg',
  weight_113_5kg: 'weight_113_5kg',
  weight_114kg: 'weight_114kg',
  weight_114_5kg: 'weight_114_5kg',
  weight_115kg: 'weight_115kg',
  weight_115_5kg: 'weight_115_5kg',
  weight_116kg: 'weight_116kg',
  weight_116_5kg: 'weight_116_5kg',
  weight_117kg: 'weight_117kg',
  weight_117_5kg: 'weight_117_5kg',
  weight_118kg: 'weight_118kg',
  weight_118_5kg: 'weight_118_5kg',
  weight_119kg: 'weight_119kg',
  weight_119_5kg: 'weight_119_5kg',
  weight_120kg: 'weight_120kg',
  weight_120_5kg: 'weight_120_5kg',
  weight_121kg: 'weight_121kg',
  weight_121_5kg: 'weight_121_5kg',
  weight_122kg: 'weight_122kg',
  weight_122_5kg: 'weight_122_5kg',
  weight_123kg: 'weight_123kg',
  weight_123_5kg: 'weight_123_5kg',
  weight_124kg: 'weight_124kg',
  weight_124_5kg: 'weight_124_5kg',
  weight_125kg: 'weight_125kg',
  weight_125_5kg: 'weight_125_5kg',
  weight_126kg: 'weight_126kg',
  weight_126_5kg: 'weight_126_5kg',
  weight_127kg: 'weight_127kg',
  weight_127_5kg: 'weight_127_5kg',
  weight_128kg: 'weight_128kg',
  weight_128_5kg: 'weight_128_5kg',
  weight_129kg: 'weight_129kg',
  weight_129_5kg: 'weight_129_5kg',
  weight_130kg: 'weight_130kg',
  weight_130_5kg: 'weight_130_5kg',
  weight_131kg: 'weight_131kg',
  weight_131_5kg: 'weight_131_5kg',
  weight_132kg: 'weight_132kg',
  weight_132_5kg: 'weight_132_5kg',
  weight_133kg: 'weight_133kg',
  weight_133_5kg: 'weight_133_5kg',
  weight_134kg: 'weight_134kg',
  weight_134_5kg: 'weight_134_5kg',
  weight_135kg: 'weight_135kg',
  weight_135_5kg: 'weight_135_5kg',
  weight_136kg: 'weight_136kg',
  weight_136_5kg: 'weight_136_5kg',
  weight_137kg: 'weight_137kg',
  weight_137_5kg: 'weight_137_5kg',
  weight_138kg: 'weight_138kg',
  weight_138_5kg: 'weight_138_5kg',
  weight_139kg: 'weight_139kg',
  weight_139_5kg: 'weight_139_5kg',
  weight_140kg: 'weight_140kg',
  weight_140_5kg: 'weight_140_5kg',
  weight_141kg: 'weight_141kg',
  weight_141_5kg: 'weight_141_5kg',
  weight_142kg: 'weight_142kg',
  weight_142_5kg: 'weight_142_5kg',
  weight_143kg: 'weight_143kg',
  weight_143_5kg: 'weight_143_5kg',
  weight_144kg: 'weight_144kg',
  weight_144_5kg: 'weight_144_5kg',
  weight_145kg: 'weight_145kg',
  weight_145_5kg: 'weight_145_5kg',
  weight_146kg: 'weight_146kg',
  weight_146_5kg: 'weight_146_5kg',
  weight_147kg: 'weight_147kg',
  weight_147_5kg: 'weight_147_5kg',
  weight_148kg: 'weight_148kg',
  weight_148_5kg: 'weight_148_5kg',
  weight_149kg: 'weight_149kg',
  weight_149_5kg: 'weight_149_5kg',
  weight_150kg: 'weight_150kg',
  weight_150_5kg: 'weight_150_5kg',
  weight_151kg: 'weight_151kg',
  weight_151_5kg: 'weight_151_5kg',
  weight_152kg: 'weight_152kg',
  weight_152_5kg: 'weight_152_5kg',
  weight_153kg: 'weight_153kg',
  weight_153_5kg: 'weight_153_5kg',
  weight_154kg: 'weight_154kg',
  weight_154_5kg: 'weight_154_5kg',
  weight_155kg: 'weight_155kg',
  weight_155_5kg: 'weight_155_5kg',
  weight_156kg: 'weight_156kg',
  weight_156_5kg: 'weight_156_5kg',
  weight_157kg: 'weight_157kg',
  weight_157_5kg: 'weight_157_5kg',
  weight_158kg: 'weight_158kg',
  weight_158_5kg: 'weight_158_5kg',
  weight_159kg: 'weight_159kg',
  weight_159_5kg: 'weight_159_5kg',
  weight_160kg: 'weight_160kg',
  weight_160_5kg: 'weight_160_5kg',
  weight_161kg: 'weight_161kg',
  weight_161_5kg: 'weight_161_5kg',
  weight_162kg: 'weight_162kg',
  weight_162_5kg: 'weight_162_5kg',
  weight_163kg: 'weight_163kg',
  weight_163_5kg: 'weight_163_5kg',
  weight_164kg: 'weight_164kg',
  weight_164_5kg: 'weight_164_5kg',
  weight_165kg: 'weight_165kg',
  weight_165_5kg: 'weight_165_5kg',
  weight_166kg: 'weight_166kg',
  weight_166_5kg: 'weight_166_5kg',
  weight_167kg: 'weight_167kg',
  weight_167_5kg: 'weight_167_5kg',
  weight_168kg: 'weight_168kg',
  weight_168_5kg: 'weight_168_5kg',
  weight_169kg: 'weight_169kg',
  weight_169_5kg: 'weight_169_5kg',
  weight_170kg: 'weight_170kg',
  weight_170_5kg: 'weight_170_5kg',
  weight_171kg: 'weight_171kg',
  weight_171_5kg: 'weight_171_5kg',
  weight_172kg: 'weight_172kg',
  weight_172_5kg: 'weight_172_5kg',
  weight_173kg: 'weight_173kg',
  weight_173_5kg: 'weight_173_5kg',
  weight_174kg: 'weight_174kg',
  weight_174_5kg: 'weight_174_5kg',
  weight_175kg: 'weight_175kg',
  weight_175_5kg: 'weight_175_5kg',
  weight_176kg: 'weight_176kg',
  weight_176_5kg: 'weight_176_5kg',
  weight_177kg: 'weight_177kg',
  weight_177_5kg: 'weight_177_5kg',
  weight_178kg: 'weight_178kg',
  weight_178_5kg: 'weight_178_5kg',
  weight_179kg: 'weight_179kg',
  weight_179_5kg: 'weight_179_5kg',
  weight_180kg: 'weight_180kg',
  weight_180_5kg: 'weight_180_5kg',
  weight_181kg: 'weight_181kg',
  weight_181_5kg: 'weight_181_5kg',
  weight_182kg: 'weight_182kg',
  weight_182_5kg: 'weight_182_5kg',
  weight_183kg: 'weight_183kg',
  weight_183_5kg: 'weight_183_5kg',
  weight_184kg: 'weight_184kg',
  weight_184_5kg: 'weight_184_5kg',
  weight_185kg: 'weight_185kg',
  weight_185_5kg: 'weight_185_5kg',
  weight_186kg: 'weight_186kg',
  weight_186_5kg: 'weight_186_5kg',
  weight_187kg: 'weight_187kg',
  weight_187_5kg: 'weight_187_5kg',
  weight_188kg: 'weight_188kg',
  weight_188_5kg: 'weight_188_5kg',
  weight_189kg: 'weight_189kg',
  weight_189_5kg: 'weight_189_5kg',
  weight_190kg: 'weight_190kg',
  weight_190_5kg: 'weight_190_5kg',
  weight_191kg: 'weight_191kg',
  weight_191_5kg: 'weight_191_5kg',
  weight_192kg: 'weight_192kg',
  weight_192_5kg: 'weight_192_5kg',
  weight_193kg: 'weight_193kg',
  weight_193_5kg: 'weight_193_5kg',
  weight_194kg: 'weight_194kg',
  weight_194_5kg: 'weight_194_5kg',
  weight_195kg: 'weight_195kg',
  weight_195_5kg: 'weight_195_5kg',
  weight_196kg: 'weight_196kg',
  weight_196_5kg: 'weight_196_5kg',
  weight_197kg: 'weight_197kg',
  weight_197_5kg: 'weight_197_5kg',
  weight_198kg: 'weight_198kg',
  weight_198_5kg: 'weight_198_5kg',
  weight_199kg: 'weight_199kg',
  weight_199_5kg: 'weight_199_5kg',
  weight_200kg: 'weight_200kg',
  weight_200_5kg: 'weight_200_5kg',
  weight_201kg: 'weight_201kg',
  weight_201_5kg: 'weight_201_5kg',
  weight_202kg: 'weight_202kg',
  weight_202_5kg: 'weight_202_5kg',
  weight_203kg: 'weight_203kg',
  weight_203_5kg: 'weight_203_5kg',
  weight_204kg: 'weight_204kg',
  weight_204_5kg: 'weight_204_5kg',
  weight_205kg: 'weight_205kg',
  weight_205_5kg: 'weight_205_5kg',
  weight_206kg: 'weight_206kg',
  weight_206_5kg: 'weight_206_5kg',
  weight_207kg: 'weight_207kg',
  weight_207_5kg: 'weight_207_5kg',
  weight_208kg: 'weight_208kg',
  weight_208_5kg: 'weight_208_5kg',
  weight_209kg: 'weight_209kg',
  weight_209_5kg: 'weight_209_5kg',
  weight_210kg: 'weight_210kg',
  weight_210_5kg: 'weight_210_5kg',
  weight_211kg: 'weight_211kg',
  weight_211_5kg: 'weight_211_5kg',
  weight_212kg: 'weight_212kg',
  weight_212_5kg: 'weight_212_5kg',
  weight_213kg: 'weight_213kg',
  weight_213_5kg: 'weight_213_5kg',
  weight_214kg: 'weight_214kg',
  weight_214_5kg: 'weight_214_5kg',
  weight_215kg: 'weight_215kg',
  weight_215_5kg: 'weight_215_5kg',
  weight_216kg: 'weight_216kg',
  weight_216_5kg: 'weight_216_5kg',
  weight_217kg: 'weight_217kg',
  weight_217_5kg: 'weight_217_5kg',
  weight_218kg: 'weight_218kg',
  weight_218_5kg: 'weight_218_5kg',
  weight_219kg: 'weight_219kg',
  weight_219_5kg: 'weight_219_5kg',
  weight_220kg: 'weight_220kg',
  weight_220_5kg: 'weight_220_5kg',
  weight_221kg: 'weight_221kg',
  weight_221_5kg: 'weight_221_5kg',
  weight_222kg: 'weight_222kg',
  weight_222_5kg: 'weight_222_5kg',
  weight_223kg: 'weight_223kg',
  weight_223_5kg: 'weight_223_5kg',
  weight_224kg: 'weight_224kg',
  weight_224_5kg: 'weight_224_5kg',
  weight_225kg: 'weight_225kg',
  weight_225_5kg: 'weight_225_5kg',
  weight_226kg: 'weight_226kg',
  weight_226_5kg: 'weight_226_5kg',
  weight_227kg: 'weight_227kg',
  weight_227_5kg: 'weight_227_5kg',
  weight_228kg: 'weight_228kg',
  weight_228_5kg: 'weight_228_5kg',
  weight_229kg: 'weight_229kg',
  weight_229_5kg: 'weight_229_5kg',
  weight_230kg: 'weight_230kg',
  weight_230_5kg: 'weight_230_5kg',
  weight_231kg: 'weight_231kg',
  weight_231_5kg: 'weight_231_5kg',
  weight_232kg: 'weight_232kg',
  weight_232_5kg: 'weight_232_5kg',
  weight_233kg: 'weight_233kg',
  weight_233_5kg: 'weight_233_5kg',
  weight_234kg: 'weight_234kg',
  weight_234_5kg: 'weight_234_5kg',
  weight_235kg: 'weight_235kg',
  weight_235_5kg: 'weight_235_5kg',
  weight_236kg: 'weight_236kg',
  weight_236_5kg: 'weight_236_5kg',
  weight_237kg: 'weight_237kg',
  weight_237_5kg: 'weight_237_5kg',
  weight_238kg: 'weight_238kg',
  weight_238_5kg: 'weight_238_5kg',
  weight_239kg: 'weight_239kg',
  weight_239_5kg: 'weight_239_5kg',
  weight_240kg: 'weight_240kg',
  weight_240_5kg: 'weight_240_5kg',
  weight_241kg: 'weight_241kg',
  weight_241_5kg: 'weight_241_5kg',
  weight_242kg: 'weight_242kg',
  weight_242_5kg: 'weight_242_5kg',
  weight_243kg: 'weight_243kg',
  weight_243_5kg: 'weight_243_5kg',
  weight_244kg: 'weight_244kg',
  weight_244_5kg: 'weight_244_5kg',
  weight_245kg: 'weight_245kg',
  weight_245_5kg: 'weight_245_5kg',
  weight_246kg: 'weight_246kg',
  weight_246_5kg: 'weight_246_5kg',
  weight_247kg: 'weight_247kg',
  weight_247_5kg: 'weight_247_5kg',
  weight_248kg: 'weight_248kg',
  weight_248_5kg: 'weight_248_5kg',
  weight_249kg: 'weight_249kg',
  weight_249_5kg: 'weight_249_5kg',
  weight_250kg: 'weight_250kg',
  weight_250_5kg: 'weight_250_5kg',
  weight_251kg: 'weight_251kg',
  weight_251_5kg: 'weight_251_5kg',
  weight_252kg: 'weight_252kg',
  weight_252_5kg: 'weight_252_5kg',
  weight_253kg: 'weight_253kg',
  weight_253_5kg: 'weight_253_5kg',
  weight_254kg: 'weight_254kg',
  weight_254_5kg: 'weight_254_5kg',
  weight_255kg: 'weight_255kg',
  weight_255_5kg: 'weight_255_5kg',
  weight_256kg: 'weight_256kg',
  weight_256_5kg: 'weight_256_5kg',
  weight_257kg: 'weight_257kg',
  weight_257_5kg: 'weight_257_5kg',
  weight_258kg: 'weight_258kg',
  weight_258_5kg: 'weight_258_5kg',
  weight_259kg: 'weight_259kg',
  weight_259_5kg: 'weight_259_5kg',
  weight_260kg: 'weight_260kg',
  weight_260_5kg: 'weight_260_5kg',
  weight_261kg: 'weight_261kg',
  weight_261_5kg: 'weight_261_5kg',
  weight_262kg: 'weight_262kg',
  weight_262_5kg: 'weight_262_5kg',
  weight_263kg: 'weight_263kg',
  weight_263_5kg: 'weight_263_5kg',
  weight_264kg: 'weight_264kg',
  weight_264_5kg: 'weight_264_5kg',
  weight_265kg: 'weight_265kg',
  weight_265_5kg: 'weight_265_5kg',
  weight_266kg: 'weight_266kg',
  weight_266_5kg: 'weight_266_5kg',
  weight_267kg: 'weight_267kg',
  weight_267_5kg: 'weight_267_5kg',
  weight_268kg: 'weight_268kg',
  weight_268_5kg: 'weight_268_5kg',
  weight_269kg: 'weight_269kg',
  weight_269_5kg: 'weight_269_5kg',
  weight_270kg: 'weight_270kg',
  weight_270_5kg: 'weight_270_5kg',
  weight_271kg: 'weight_271kg',
  weight_271_5kg: 'weight_271_5kg',
  weight_272kg: 'weight_272kg',
  weight_272_5kg: 'weight_272_5kg',
  weight_273kg: 'weight_273kg',
  weight_273_5kg: 'weight_273_5kg',
  weight_274kg: 'weight_274kg',
  weight_274_5kg: 'weight_274_5kg',
  weight_275kg: 'weight_275kg',
  weight_275_5kg: 'weight_275_5kg',
  weight_276kg: 'weight_276kg',
  weight_276_5kg: 'weight_276_5kg',
  weight_277kg: 'weight_277kg',
  weight_277_5kg: 'weight_277_5kg',
  weight_278kg: 'weight_278kg',
  weight_278_5kg: 'weight_278_5kg',
  weight_279kg: 'weight_279kg',
  weight_279_5kg: 'weight_279_5kg',
  weight_280kg: 'weight_280kg',
  weight_280_5kg: 'weight_280_5kg',
  weight_281kg: 'weight_281kg',
  weight_281_5kg: 'weight_281_5kg',
  weight_282kg: 'weight_282kg',
  weight_282_5kg: 'weight_282_5kg',
  weight_283kg: 'weight_283kg',
  weight_283_5kg: 'weight_283_5kg',
  weight_284kg: 'weight_284kg',
  weight_284_5kg: 'weight_284_5kg',
  weight_285kg: 'weight_285kg',
  weight_285_5kg: 'weight_285_5kg',
  weight_286kg: 'weight_286kg',
  weight_286_5kg: 'weight_286_5kg',
  weight_287kg: 'weight_287kg',
  weight_287_5kg: 'weight_287_5kg',
  weight_288kg: 'weight_288kg',
  weight_288_5kg: 'weight_288_5kg',
  weight_289kg: 'weight_289kg',
  weight_289_5kg: 'weight_289_5kg',
  weight_290kg: 'weight_290kg',
  weight_290_5kg: 'weight_290_5kg',
  weight_291kg: 'weight_291kg',
  weight_291_5kg: 'weight_291_5kg',
  weight_292kg: 'weight_292kg',
  weight_292_5kg: 'weight_292_5kg',
  weight_293kg: 'weight_293kg',
  weight_293_5kg: 'weight_293_5kg',
  weight_294kg: 'weight_294kg',
  weight_294_5kg: 'weight_294_5kg',
  weight_295kg: 'weight_295kg',
  weight_295_5kg: 'weight_295_5kg',
  weight_296kg: 'weight_296kg',
  weight_296_5kg: 'weight_296_5kg',
  weight_297kg: 'weight_297kg',
  weight_297_5kg: 'weight_297_5kg',
  weight_298kg: 'weight_298kg',
  weight_298_5kg: 'weight_298_5kg',
  weight_299kg: 'weight_299kg',
  weight_299_5kg: 'weight_299_5kg',
  weight_300kg: 'weight_300kg',
  weight_300_5kg: 'weight_300_5kg',
  weight_301kg: 'weight_301kg',
  weight_301_5kg: 'weight_301_5kg',
  weight_302kg: 'weight_302kg',
  weight_302_5kg: 'weight_302_5kg',
  weight_303kg: 'weight_303kg',
  weight_303_5kg: 'weight_303_5kg',
  weight_304kg: 'weight_304kg',
  weight_304_5kg: 'weight_304_5kg',
  weight_305kg: 'weight_305kg',
  weight_305_5kg: 'weight_305_5kg',
  weight_306kg: 'weight_306kg',
  weight_306_5kg: 'weight_306_5kg',
  weight_307kg: 'weight_307kg',
  weight_307_5kg: 'weight_307_5kg',
  weight_308kg: 'weight_308kg',
  weight_308_5kg: 'weight_308_5kg',
  weight_309kg: 'weight_309kg',
  weight_309_5kg: 'weight_309_5kg',
  weight_310kg: 'weight_310kg',
  weight_310_5kg: 'weight_310_5kg',
  weight_311kg: 'weight_311kg',
  weight_311_5kg: 'weight_311_5kg',
  weight_312kg: 'weight_312kg',
  weight_312_5kg: 'weight_312_5kg',
  weight_313kg: 'weight_313kg',
  weight_313_5kg: 'weight_313_5kg',
  weight_314kg: 'weight_314kg',
  weight_314_5kg: 'weight_314_5kg',
  weight_315kg: 'weight_315kg',
  weight_315_5kg: 'weight_315_5kg',
  weight_316kg: 'weight_316kg',
  weight_316_5kg: 'weight_316_5kg',
  weight_317kg: 'weight_317kg',
  weight_317_5kg: 'weight_317_5kg',
  weight_318kg: 'weight_318kg',
  weight_318_5kg: 'weight_318_5kg',
  weight_319kg: 'weight_319kg',
  weight_319_5kg: 'weight_319_5kg',
  weight_320kg: 'weight_320kg',
  weight_320_5kg: 'weight_320_5kg',
  weight_321kg: 'weight_321kg',
  weight_321_5kg: 'weight_321_5kg',
  weight_322kg: 'weight_322kg',
  weight_322_5kg: 'weight_322_5kg',
  weight_323kg: 'weight_323kg',
  weight_323_5kg: 'weight_323_5kg',
  weight_324kg: 'weight_324kg',
  weight_324_5kg: 'weight_324_5kg',
  weight_325kg: 'weight_325kg',
  weight_325_5kg: 'weight_325_5kg',
  weight_326kg: 'weight_326kg',
  weight_326_5kg: 'weight_326_5kg',
  weight_327kg: 'weight_327kg',
  weight_327_5kg: 'weight_327_5kg',
  weight_328kg: 'weight_328kg',
  weight_328_5kg: 'weight_328_5kg',
  weight_329kg: 'weight_329kg',
  weight_329_5kg: 'weight_329_5kg',
  weight_330kg: 'weight_330kg',
  weight_330_5kg: 'weight_330_5kg',
  weight_331kg: 'weight_331kg',
  weight_331_5kg: 'weight_331_5kg',
  weight_332kg: 'weight_332kg',
  weight_332_5kg: 'weight_332_5kg',
  weight_333kg: 'weight_333kg',
  weight_333_5kg: 'weight_333_5kg',
  weight_334kg: 'weight_334kg',
  weight_334_5kg: 'weight_334_5kg',
  weight_335kg: 'weight_335kg',
  weight_335_5kg: 'weight_335_5kg',
  weight_336kg: 'weight_336kg',
  weight_336_5kg: 'weight_336_5kg',
  weight_337kg: 'weight_337kg',
  weight_337_5kg: 'weight_337_5kg',
  weight_338kg: 'weight_338kg',
  weight_338_5kg: 'weight_338_5kg',
  weight_339kg: 'weight_339kg',
  weight_339_5kg: 'weight_339_5kg',
  weight_340kg: 'weight_340kg',
  weight_340_5kg: 'weight_340_5kg',
  weight_341kg: 'weight_341kg',
  weight_341_5kg: 'weight_341_5kg',
  weight_342kg: 'weight_342kg',
  weight_342_5kg: 'weight_342_5kg',
  weight_343kg: 'weight_343kg',
  weight_343_5kg: 'weight_343_5kg',
  weight_344kg: 'weight_344kg',
  weight_344_5kg: 'weight_344_5kg',
  weight_345kg: 'weight_345kg',
  weight_345_5kg: 'weight_345_5kg',
  weight_346kg: 'weight_346kg',
  weight_346_5kg: 'weight_346_5kg',
  weight_347kg: 'weight_347kg',
  weight_347_5kg: 'weight_347_5kg',
  weight_348kg: 'weight_348kg',
  weight_348_5kg: 'weight_348_5kg',
  weight_349kg: 'weight_349kg',
  weight_349_5kg: 'weight_349_5kg',
  weight_350kg: 'weight_350kg',
  weight_350_5kg: 'weight_350_5kg',
  weight_351kg: 'weight_351kg',
  weight_351_5kg: 'weight_351_5kg',
  weight_352kg: 'weight_352kg',
  weight_352_5kg: 'weight_352_5kg',
  weight_353kg: 'weight_353kg',
  weight_353_5kg: 'weight_353_5kg',
  weight_354kg: 'weight_354kg',
  weight_354_5kg: 'weight_354_5kg',
  weight_355kg: 'weight_355kg',
  weight_355_5kg: 'weight_355_5kg',
  weight_356kg: 'weight_356kg',
  weight_356_5kg: 'weight_356_5kg',
  weight_357kg: 'weight_357kg',
  weight_357_5kg: 'weight_357_5kg',
  weight_358kg: 'weight_358kg',
  weight_358_5kg: 'weight_358_5kg',
  weight_359kg: 'weight_359kg',
  weight_359_5kg: 'weight_359_5kg',
  weight_360kg: 'weight_360kg',
  weight_360_5kg: 'weight_360_5kg',
  weight_361kg: 'weight_361kg',
  weight_361_5kg: 'weight_361_5kg',
  weight_362kg: 'weight_362kg',
  weight_362_5kg: 'weight_362_5kg',
  weight_363kg: 'weight_363kg',
  weight_363_5kg: 'weight_363_5kg',
  weight_364kg: 'weight_364kg',
  weight_364_5kg: 'weight_364_5kg',
  weight_365kg: 'weight_365kg',
  weight_365_5kg: 'weight_365_5kg',
  weight_366kg: 'weight_366kg',
  weight_366_5kg: 'weight_366_5kg',
  weight_367kg: 'weight_367kg',
  weight_367_5kg: 'weight_367_5kg',
  weight_368kg: 'weight_368kg',
  weight_368_5kg: 'weight_368_5kg',
  weight_369kg: 'weight_369kg',
  weight_369_5kg: 'weight_369_5kg',
  weight_370kg: 'weight_370kg',
  weight_370_5kg: 'weight_370_5kg',
  weight_371kg: 'weight_371kg',
  weight_371_5kg: 'weight_371_5kg',
  weight_372kg: 'weight_372kg',
  weight_372_5kg: 'weight_372_5kg',
  weight_373kg: 'weight_373kg',
  weight_373_5kg: 'weight_373_5kg',
  weight_374kg: 'weight_374kg',
  weight_374_5kg: 'weight_374_5kg',
  weight_375kg: 'weight_375kg',
  weight_375_5kg: 'weight_375_5kg',
  weight_376kg: 'weight_376kg',
  weight_376_5kg: 'weight_376_5kg',
  weight_377kg: 'weight_377kg',
  weight_377_5kg: 'weight_377_5kg',
  weight_378kg: 'weight_378kg',
  weight_378_5kg: 'weight_378_5kg',
  weight_379kg: 'weight_379kg',
  weight_379_5kg: 'weight_379_5kg',
  weight_380kg: 'weight_380kg',
  weight_380_5kg: 'weight_380_5kg',
  weight_381kg: 'weight_381kg',
  weight_381_5kg: 'weight_381_5kg',
  weight_382kg: 'weight_382kg',
  weight_382_5kg: 'weight_382_5kg',
  weight_383kg: 'weight_383kg',
  weight_383_5kg: 'weight_383_5kg',
  weight_384kg: 'weight_384kg',
  weight_384_5kg: 'weight_384_5kg',
  weight_385kg: 'weight_385kg',
  weight_385_5kg: 'weight_385_5kg',
  weight_386kg: 'weight_386kg',
  weight_386_5kg: 'weight_386_5kg',
  weight_387kg: 'weight_387kg',
  weight_387_5kg: 'weight_387_5kg',
  weight_388kg: 'weight_388kg',
  weight_388_5kg: 'weight_388_5kg',
  weight_389kg: 'weight_389kg',
  weight_389_5kg: 'weight_389_5kg',
  weight_390kg: 'weight_390kg',
  weight_390_5kg: 'weight_390_5kg',
  weight_391kg: 'weight_391kg',
  weight_391_5kg: 'weight_391_5kg',
  weight_392kg: 'weight_392kg',
  weight_392_5kg: 'weight_392_5kg',
  weight_393kg: 'weight_393kg',
  weight_393_5kg: 'weight_393_5kg',
  weight_394kg: 'weight_394kg',
  weight_394_5kg: 'weight_394_5kg',
  weight_395kg: 'weight_395kg',
  weight_395_5kg: 'weight_395_5kg',
  weight_396kg: 'weight_396kg',
  weight_396_5kg: 'weight_396_5kg',
  weight_397kg: 'weight_397kg',
  weight_397_5kg: 'weight_397_5kg',
  weight_398kg: 'weight_398kg',
  weight_398_5kg: 'weight_398_5kg',
  weight_399kg: 'weight_399kg',
  weight_399_5kg: 'weight_399_5kg',
  weight_400kg: 'weight_400kg',
  weight_400_5kg: 'weight_400_5kg',
  weight_401kg: 'weight_401kg',
  weight_401_5kg: 'weight_401_5kg',
  weight_402kg: 'weight_402kg',
  weight_402_5kg: 'weight_402_5kg',
  weight_403kg: 'weight_403kg',
  weight_403_5kg: 'weight_403_5kg',
  weight_404kg: 'weight_404kg',
  weight_404_5kg: 'weight_404_5kg',
  weight_405kg: 'weight_405kg',
  weight_405_5kg: 'weight_405_5kg',
  weight_406kg: 'weight_406kg',
  weight_406_5kg: 'weight_406_5kg',
  weight_407kg: 'weight_407kg',
  weight_407_5kg: 'weight_407_5kg',
  weight_408kg: 'weight_408kg',
  weight_408_5kg: 'weight_408_5kg',
  weight_409kg: 'weight_409kg',
  weight_409_5kg: 'weight_409_5kg',
  weight_410kg: 'weight_410kg',
  weight_410_5kg: 'weight_410_5kg',
  weight_411kg: 'weight_411kg',
  weight_411_5kg: 'weight_411_5kg',
  weight_412kg: 'weight_412kg',
  weight_412_5kg: 'weight_412_5kg',
  weight_413kg: 'weight_413kg',
  weight_413_5kg: 'weight_413_5kg',
  weight_414kg: 'weight_414kg',
  weight_414_5kg: 'weight_414_5kg',
  weight_415kg: 'weight_415kg',
  weight_415_5kg: 'weight_415_5kg',
  weight_416kg: 'weight_416kg',
  weight_416_5kg: 'weight_416_5kg',
  weight_417kg: 'weight_417kg',
  weight_417_5kg: 'weight_417_5kg',
  weight_418kg: 'weight_418kg',
  weight_418_5kg: 'weight_418_5kg',
  weight_419kg: 'weight_419kg',
  weight_419_5kg: 'weight_419_5kg',
  weight_420kg: 'weight_420kg',
  weight_420_5kg: 'weight_420_5kg',
  weight_421kg: 'weight_421kg',
  weight_421_5kg: 'weight_421_5kg',
  weight_422kg: 'weight_422kg',
  weight_422_5kg: 'weight_422_5kg',
  weight_423kg: 'weight_423kg',
  weight_423_5kg: 'weight_423_5kg',
  weight_424kg: 'weight_424kg',
  weight_424_5kg: 'weight_424_5kg',
  weight_425kg: 'weight_425kg',
  weight_425_5kg: 'weight_425_5kg',
  weight_426kg: 'weight_426kg',
  weight_426_5kg: 'weight_426_5kg',
  weight_427kg: 'weight_427kg',
  weight_427_5kg: 'weight_427_5kg',
  weight_428kg: 'weight_428kg',
  weight_428_5kg: 'weight_428_5kg',
  weight_429kg: 'weight_429kg',
  weight_429_5kg: 'weight_429_5kg',
  weight_430kg: 'weight_430kg',
  weight_430_5kg: 'weight_430_5kg',
  weight_431kg: 'weight_431kg',
  weight_431_5kg: 'weight_431_5kg',
  weight_432kg: 'weight_432kg',
  weight_432_5kg: 'weight_432_5kg',
  weight_433kg: 'weight_433kg',
  weight_433_5kg: 'weight_433_5kg',
  weight_434kg: 'weight_434kg',
  weight_434_5kg: 'weight_434_5kg',
  weight_435kg: 'weight_435kg',
  weight_435_5kg: 'weight_435_5kg',
  weight_436kg: 'weight_436kg',
  weight_436_5kg: 'weight_436_5kg',
  weight_437kg: 'weight_437kg',
  weight_437_5kg: 'weight_437_5kg',
  weight_438kg: 'weight_438kg',
  weight_438_5kg: 'weight_438_5kg',
  weight_439kg: 'weight_439kg',
  weight_439_5kg: 'weight_439_5kg',
  weight_440kg: 'weight_440kg',
  weight_440_5kg: 'weight_440_5kg',
  weight_441kg: 'weight_441kg',
  weight_441_5kg: 'weight_441_5kg',
  weight_442kg: 'weight_442kg',
  weight_442_5kg: 'weight_442_5kg',
  weight_443kg: 'weight_443kg',
  weight_443_5kg: 'weight_443_5kg',
  weight_444kg: 'weight_444kg',
  weight_444_5kg: 'weight_444_5kg',
  weight_445kg: 'weight_445kg',
  weight_445_5kg: 'weight_445_5kg',
  weight_446kg: 'weight_446kg',
  weight_446_5kg: 'weight_446_5kg',
  weight_447kg: 'weight_447kg',
  weight_447_5kg: 'weight_447_5kg',
  weight_448kg: 'weight_448kg',
  weight_448_5kg: 'weight_448_5kg',
  weight_449kg: 'weight_449kg',
  weight_449_5kg: 'weight_449_5kg',
  weight_450kg: 'weight_450kg',
  weight_450_5kg: 'weight_450_5kg',
  weight_451kg: 'weight_451kg',
  weight_451_5kg: 'weight_451_5kg',
  weight_452kg: 'weight_452kg',
  weight_452_5kg: 'weight_452_5kg',
  weight_453kg: 'weight_453kg',
  weight_453_5kg: 'weight_453_5kg',
  weight_454kg: 'weight_454kg',
  weight_454_5kg: 'weight_454_5kg',
  weight_455kg: 'weight_455kg',
  weight_455_5kg: 'weight_455_5kg',
  weight_456kg: 'weight_456kg',
  weight_456_5kg: 'weight_456_5kg',
  weight_457kg: 'weight_457kg',
  weight_457_5kg: 'weight_457_5kg',
  weight_458kg: 'weight_458kg',
  weight_458_5kg: 'weight_458_5kg',
  weight_459kg: 'weight_459kg',
  weight_459_5kg: 'weight_459_5kg',
  weight_460kg: 'weight_460kg',
  weight_460_5kg: 'weight_460_5kg',
  weight_461kg: 'weight_461kg',
  weight_461_5kg: 'weight_461_5kg',
  weight_462kg: 'weight_462kg',
  weight_462_5kg: 'weight_462_5kg',
  weight_463kg: 'weight_463kg',
  weight_463_5kg: 'weight_463_5kg',
  weight_464kg: 'weight_464kg',
  weight_464_5kg: 'weight_464_5kg',
  weight_465kg: 'weight_465kg',
  weight_465_5kg: 'weight_465_5kg',
  weight_466kg: 'weight_466kg',
  weight_466_5kg: 'weight_466_5kg',
  weight_467kg: 'weight_467kg',
  weight_467_5kg: 'weight_467_5kg',
  weight_468kg: 'weight_468kg',
  weight_468_5kg: 'weight_468_5kg',
  weight_469kg: 'weight_469kg',
  weight_469_5kg: 'weight_469_5kg',
  weight_470kg: 'weight_470kg',
  weight_470_5kg: 'weight_470_5kg',
  weight_471kg: 'weight_471kg',
  weight_471_5kg: 'weight_471_5kg',
  weight_472kg: 'weight_472kg',
  weight_472_5kg: 'weight_472_5kg',
  weight_473kg: 'weight_473kg',
  weight_473_5kg: 'weight_473_5kg',
  weight_474kg: 'weight_474kg',
  weight_474_5kg: 'weight_474_5kg',
  weight_475kg: 'weight_475kg',
  weight_475_5kg: 'weight_475_5kg',
  weight_476kg: 'weight_476kg',
  weight_476_5kg: 'weight_476_5kg',
  weight_477kg: 'weight_477kg',
  weight_477_5kg: 'weight_477_5kg',
  weight_478kg: 'weight_478kg',
  weight_478_5kg: 'weight_478_5kg',
  weight_479kg: 'weight_479kg',
  weight_479_5kg: 'weight_479_5kg',
  weight_480kg: 'weight_480kg',
  weight_480_5kg: 'weight_480_5kg',
  weight_481kg: 'weight_481kg',
  weight_481_5kg: 'weight_481_5kg',
  weight_482kg: 'weight_482kg',
  weight_482_5kg: 'weight_482_5kg',
  weight_483kg: 'weight_483kg',
  weight_483_5kg: 'weight_483_5kg',
  weight_484kg: 'weight_484kg',
  weight_484_5kg: 'weight_484_5kg',
  weight_485kg: 'weight_485kg',
  weight_485_5kg: 'weight_485_5kg',
  weight_486kg: 'weight_486kg',
  weight_486_5kg: 'weight_486_5kg',
  weight_487kg: 'weight_487kg',
  weight_487_5kg: 'weight_487_5kg',
  weight_488kg: 'weight_488kg',
  weight_488_5kg: 'weight_488_5kg',
  weight_489kg: 'weight_489kg',
  weight_489_5kg: 'weight_489_5kg',
  weight_490kg: 'weight_490kg',
  weight_490_5kg: 'weight_490_5kg',
  weight_491kg: 'weight_491kg',
  weight_491_5kg: 'weight_491_5kg',
  weight_492kg: 'weight_492kg',
  weight_492_5kg: 'weight_492_5kg',
  weight_493kg: 'weight_493kg',
  weight_493_5kg: 'weight_493_5kg',
  weight_494kg: 'weight_494kg',
  weight_494_5kg: 'weight_494_5kg',
  weight_495kg: 'weight_495kg',
  weight_495_5kg: 'weight_495_5kg',
  weight_496kg: 'weight_496kg',
  weight_496_5kg: 'weight_496_5kg',
  weight_497kg: 'weight_497kg'
};

exports.Prisma.Disc_prices_orig_users_till_50kg_v2ScalarFieldEnum = {
  Country: 'Country',
  code: 'code',
  kg: 'kg',
  weight_0_5kg: 'weight_0_5kg',
  weight_1kg: 'weight_1kg',
  weight_1_5kg: 'weight_1_5kg',
  weight_2kg: 'weight_2kg',
  weight_2_5kg: 'weight_2_5kg',
  weight_3kg: 'weight_3kg',
  weight_3_5kg: 'weight_3_5kg',
  weight_4kg: 'weight_4kg',
  weight_4_5kg: 'weight_4_5kg',
  weight_5kg: 'weight_5kg',
  weight_5_5kg: 'weight_5_5kg',
  weight_6kg: 'weight_6kg',
  weight_6_5kg: 'weight_6_5kg',
  weight_7kg: 'weight_7kg',
  weight_7_5kg: 'weight_7_5kg',
  weight_8kg: 'weight_8kg',
  weight_8_5kg: 'weight_8_5kg',
  weight_9kg: 'weight_9kg',
  weight_9_5kg: 'weight_9_5kg',
  weight_10kg: 'weight_10kg',
  weight_10_5kg: 'weight_10_5kg',
  weight_11kg: 'weight_11kg',
  weight_11_5kg: 'weight_11_5kg',
  weight_12kg: 'weight_12kg',
  weight_12_5kg: 'weight_12_5kg',
  weight_13kg: 'weight_13kg',
  weight_13_5kg: 'weight_13_5kg',
  weight_14kg: 'weight_14kg',
  weight_14_5kg: 'weight_14_5kg',
  weight_15kg: 'weight_15kg',
  weight_15_5kg: 'weight_15_5kg',
  weight_16kg: 'weight_16kg',
  weight_16_5kg: 'weight_16_5kg',
  weight_17kg: 'weight_17kg',
  weight_17_5kg: 'weight_17_5kg',
  weight_18kg: 'weight_18kg',
  weight_18_5kg: 'weight_18_5kg',
  weight_19kg: 'weight_19kg',
  weight_19_5kg: 'weight_19_5kg',
  weight_20kg: 'weight_20kg',
  weight_20_5kg: 'weight_20_5kg',
  weight_21kg: 'weight_21kg',
  weight_21_5kg: 'weight_21_5kg',
  weight_22kg: 'weight_22kg',
  weight_22_5kg: 'weight_22_5kg',
  weight_23kg: 'weight_23kg',
  weight_23_5kg: 'weight_23_5kg',
  weight_24kg: 'weight_24kg',
  weight_24_5kg: 'weight_24_5kg',
  weight_25kg: 'weight_25kg',
  weight_25_5kg: 'weight_25_5kg',
  weight_26kg: 'weight_26kg',
  weight_26_5kg: 'weight_26_5kg',
  weight_27kg: 'weight_27kg',
  weight_27_5kg: 'weight_27_5kg',
  weight_28kg: 'weight_28kg',
  weight_28_5kg: 'weight_28_5kg',
  weight_29kg: 'weight_29kg',
  weight_29_5kg: 'weight_29_5kg',
  weight_30kg: 'weight_30kg',
  weight_30_5kg: 'weight_30_5kg',
  weight_31kg: 'weight_31kg',
  weight_31_5kg: 'weight_31_5kg',
  weight_32kg: 'weight_32kg',
  weight_32_5kg: 'weight_32_5kg',
  weight_33kg: 'weight_33kg',
  weight_33_5kg: 'weight_33_5kg',
  weight_34kg: 'weight_34kg',
  weight_34_5kg: 'weight_34_5kg',
  weight_35kg: 'weight_35kg',
  weight_35_5kg: 'weight_35_5kg',
  weight_36kg: 'weight_36kg',
  weight_36_5kg: 'weight_36_5kg',
  weight_37kg: 'weight_37kg',
  weight_37_5kg: 'weight_37_5kg',
  weight_38kg: 'weight_38kg',
  weight_38_5kg: 'weight_38_5kg',
  weight_39kg: 'weight_39kg',
  weight_39_5kg: 'weight_39_5kg',
  weight_40kg: 'weight_40kg',
  weight_40_5kg: 'weight_40_5kg',
  weight_41kg: 'weight_41kg',
  weight_41_5kg: 'weight_41_5kg',
  weight_42kg: 'weight_42kg',
  weight_42_5kg: 'weight_42_5kg',
  weight_43kg: 'weight_43kg',
  weight_43_5kg: 'weight_43_5kg',
  weight_44kg: 'weight_44kg',
  weight_44_5kg: 'weight_44_5kg',
  weight_45kg: 'weight_45kg',
  weight_45_5kg: 'weight_45_5kg',
  weight_46kg: 'weight_46kg',
  weight_46_5kg: 'weight_46_5kg',
  weight_47kg: 'weight_47kg',
  weight_47_5kg: 'weight_47_5kg',
  weight_48kg: 'weight_48kg',
  weight_48_5kg: 'weight_48_5kg',
  weight_49kg: 'weight_49kg',
  weight_49_5kg: 'weight_49_5kg',
  weight_50kg: 'weight_50kg'
};

exports.Prisma.Discount_codesScalarFieldEnum = {
  discount_code: 'discount_code',
  created_ts: 'created_ts',
  updated_ts: 'updated_ts',
  discount_amount: 'discount_amount',
  start_ts: 'start_ts',
  expiry_ts: 'expiry_ts',
  is_redeemed: 'is_redeemed',
  redeemed_ts: 'redeemed_ts',
  redeemed_amount: 'redeemed_amount',
  shipping_id: 'shipping_id',
  purchaser_user_id: 'purchaser_user_id',
  purchaser_email: 'purchaser_email',
  purchaser_name: 'purchaser_name',
  recipient_email: 'recipient_email',
  recipient_name: 'recipient_name',
  message_to_recipient: 'message_to_recipient',
  payment_reference: 'payment_reference',
  payment_ts: 'payment_ts'
};

exports.Prisma.Fedex_ratecard_net_rates_20220915ScalarFieldEnum = {
  ServiceType: 'ServiceType',
  PackageType: 'PackageType',
  Kgs: 'Kgs',
  Zone: 'Zone',
  Rate: 'Rate'
};

exports.Prisma.Fedex_ratecard_net_rates_20230510ScalarFieldEnum = {
  ServiceType: 'ServiceType',
  PackageType: 'PackageType',
  Kgs: 'Kgs',
  Zone: 'Zone',
  Rate: 'Rate'
};

exports.Prisma.Fedex_ratecard_net_rates_20230905ScalarFieldEnum = {
  ServiceType: 'ServiceType',
  PackageType: 'PackageType',
  Kgs: 'Kgs',
  Zone: 'Zone',
  Rate: 'Rate'
};

exports.Prisma.Fedex_ratecard_per_kg_20220915ScalarFieldEnum = {
  ServiceType: 'ServiceType',
  Kgs: 'Kgs',
  Zone: 'Zone',
  Rate: 'Rate'
};

exports.Prisma.Fedex_ratecard_per_kg_20230510ScalarFieldEnum = {
  ServiceType: 'ServiceType',
  Kgs: 'Kgs',
  Zone: 'Zone',
  Rate: 'Rate'
};

exports.Prisma.Fedex_ratecard_per_kg_20230905ScalarFieldEnum = {
  ServiceType: 'ServiceType',
  Kgs: 'Kgs',
  Zone: 'Zone',
  Rate: 'Rate'
};

exports.Prisma.Fedex_zone_chartScalarFieldEnum = {
  Country: 'Country',
  Code: 'Code',
  Zone: 'Zone'
};

exports.Prisma.FormtblitemdataScalarFieldEnum = {
  serialNo: 'serialNo',
  packageID: 'packageID',
  itemIX: 'itemIX',
  itemCategory: 'itemCategory',
  itemQuantity: 'itemQuantity',
  itemDescription: 'itemDescription',
  itemPrice: 'itemPrice',
  itemWeight: 'itemWeight',
  itemTotalPrice: 'itemTotalPrice',
  itemTotalWeight: 'itemTotalWeight',
  itemID: 'itemID',
  isFragile: 'isFragile',
  harmonizedCode: 'harmonizedCode'
};

exports.Prisma.FormtblparceldataScalarFieldEnum = {
  packageID: 'packageID',
  shippingID: 'shippingID',
  parcelIX: 'parcelIX',
  packingOrNotButton: 'packingOrNotButton',
  haveOrNotDimensions: 'haveOrNotDimensions',
  regularPackingServiceButton: 'regularPackingServiceButton',
  fragilePackingServiceButton: 'fragilePackingServiceButton',
  regularPackingCost: 'regularPackingCost',
  fragilePackingCost: 'fragilePackingCost',
  parcelLength: 'parcelLength',
  parcelWidth: 'parcelWidth',
  parcelHeight: 'parcelHeight',
  parcelWeight: 'parcelWeight',
  calculatedWeight: 'calculatedWeight',
  parcelSummItemWeight: 'parcelSummItemWeight',
  verifiedPackingCost: 'verifiedPackingCost',
  verifiedFragilePackingCost: 'verifiedFragilePackingCost',
  verifiedParcelLength: 'verifiedParcelLength',
  verifiedParcelWidth: 'verifiedParcelWidth',
  verifiedParcelHeight: 'verifiedParcelHeight',
  verifiedParcelWeight: 'verifiedParcelWeight',
  verifiedParcelVolumetricWeight: 'verifiedParcelVolumetricWeight',
  parcelDeclaredValue: 'parcelDeclaredValue',
  parcelSummDeclaredValue: 'parcelSummDeclaredValue',
  parcelInsuranceAmount: 'parcelInsuranceAmount',
  verifiedInsuranceAmount: 'verifiedInsuranceAmount',
  parcelQuote: 'parcelQuote',
  verifiedShippingCost: 'verifiedShippingCost',
  verifiedGreenShipping: 'verifiedGreenShipping',
  verifiedRuralSurcharge: 'verifiedRuralSurcharge',
  verifiedOthersCost: 'verifiedOthersCost',
  verifiedQuote: 'verifiedQuote',
  paymentAmount: 'paymentAmount',
  itemCount: 'itemCount',
  pickupDoneButton: 'pickupDoneButton',
  topupRequirement: 'topupRequirement',
  topupAmount1: 'topupAmount1',
  paymentTopup1: 'paymentTopup1',
  topupAmount2: 'topupAmount2',
  paymentTopup2: 'paymentTopup2',
  verificationStatus: 'verificationStatus',
  opsComments: 'opsComments',
  shipButton: 'shipButton',
  topupButton: 'topupButton',
  shipOutTimestamp: 'shipOutTimestamp',
  ruralSurcharge: 'ruralSurcharge',
  FeedbackButton: 'FeedbackButton',
  isParcelRemoved: 'isParcelRemoved',
  ignoreForQuote: 'ignoreForQuote'
};

exports.Prisma.FormtblrecipientdataScalarFieldEnum = {
  shippingID: 'shippingID',
  orderID: 'orderID',
  recipientIX: 'recipientIX',
  recName: 'recName',
  recEmail: 'recEmail',
  recPhoneNo: 'recPhoneNo',
  recCountry: 'recCountry',
  recCountryCode: 'recCountryCode',
  recAddress1: 'recAddress1',
  recAddress2: 'recAddress2',
  recAddress3: 'recAddress3',
  recCity: 'recCity',
  recState: 'recState',
  recStateOrProvinceCode: 'recStateOrProvinceCode',
  recZipCode: 'recZipCode',
  shippingPurpose: 'shippingPurpose',
  directSignature: 'directSignature',
  initialSignatureAmount: 'initialSignatureAmount',
  verifiedSignatureAmount: 'verifiedSignatureAmount',
  insuranceButton: 'insuranceButton',
  totalInsuredAmt: 'totalInsuredAmt',
  totalIndivRecParcels: 'totalIndivRecParcels',
  totalIndivRecCost: 'totalIndivRecCost',
  initialFreightQuote: 'initialFreightQuote',
  verifiedFreightQuote: 'verifiedFreightQuote',
  initialDiscountAmount: 'initialDiscountAmount',
  verifiedDiscountAmount: 'verifiedDiscountAmount',
  initialValentinesAmount: 'initialValentinesAmount',
  verifiedValentinesAmount: 'verifiedValentinesAmount',
  currencyCode: 'currencyCode',
  customValue: 'customValue',
  pkgContent: 'pkgContent',
  pkgTypeUsed: 'pkgTypeUsed',
  serviceType: 'serviceType',
  AccountNumber: 'AccountNumber',
  FedexFreightInvoice: 'FedexFreightInvoice',
  FedexTaxInvoice: 'FedexTaxInvoice',
  FuelSurchargePercent: 'FuelSurchargePercent',
  ExpectedFedExQuote: 'ExpectedFedExQuote',
  InitialFedExQuote: 'InitialFedExQuote',
  ActualFedExCharge: 'ActualFedExCharge',
  FedexFreightCharges: 'FedexFreightCharges',
  FedexBaseDiscount: 'FedexBaseDiscount',
  FedexFuelSurcharge: 'FedexFuelSurcharge',
  FedexPeakSurcharge: 'FedexPeakSurcharge',
  FedexDutyTaxes: 'FedexDutyTaxes',
  LastFailFedExReason: 'LastFailFedExReason',
  ruralSurcharge: 'ruralSurcharge',
  DataTrackRemarks: 'DataTrackRemarks',
  DutiesPaidBy: 'DutiesPaidBy',
  ImportDutyCharge: 'ImportDutyCharge',
  ImportTaxCharge: 'ImportTaxCharge',
  DutyHandlingFee: 'DutyHandlingFee',
  TotalDutiesAndTaxes: 'TotalDutiesAndTaxes',
  vImportDutyCharge: 'vImportDutyCharge',
  vImportTaxCharge: 'vImportTaxCharge',
  vDutyHandlingFee: 'vDutyHandlingFee',
  vTotalDutiesAndTaxes: 'vTotalDutiesAndTaxes',
  verificationDatetime: 'verificationDatetime',
  holdShipmentFlag: 'holdShipmentFlag',
  holdShipmentReason: 'holdShipmentReason',
  verifiedOtherCosts: 'verifiedOtherCosts',
  addedToCartDateTime: 'addedToCartDateTime',
  isCancelled: 'isCancelled',
  shopifyOrderID: 'shopifyOrderID',
  taxID: 'taxID',
  shippingMethod: 'shippingMethod',
  isBulkShipment: 'isBulkShipment',
  bulkShippingID: 'bulkShippingID',
  isStagedForConsolidation: 'isStagedForConsolidation',
  userAcceptCommodityCheck: 'userAcceptCommodityCheck',
  commodityDocuments: 'commodityDocuments'
};

exports.Prisma.FormtblsenderdataScalarFieldEnum = {
  id: 'id',
  submissionID: 'submissionID',
  submissionDateTime: 'submissionDateTime',
  submitDate: 'submitDate',
  orderID: 'orderID',
  orderIX: 'orderIX',
  senderFirstName: 'senderFirstName',
  senderLastName: 'senderLastName',
  senderEmail: 'senderEmail',
  senderPhoneNo: 'senderPhoneNo',
  dropoffPickupButton: 'dropoffPickupButton',
  dropoffDate: 'dropoffDate',
  dropoffTime: 'dropoffTime',
  pickupDate: 'pickupDate',
  pickupTime: 'pickupTime',
  pickupCountry: 'pickupCountry',
  pickupPostalCode: 'pickupPostalCode',
  pickupAddress: 'pickupAddress',
  pickupUnitNo: 'pickupUnitNo',
  pickupContactNo: 'pickupContactNo',
  refundPayNowNumber: 'refundPayNowNumber',
  totalNoOfParcels: 'totalNoOfParcels',
  totalNoOfRecipients: 'totalNoOfRecipients',
  totalAmount: 'totalAmount',
  TnC: 'TnC',
  timeSt: 'timeSt',
  payOrScheduled: 'payOrScheduled',
  addInfo: 'addInfo',
  b2b: 'b2b',
  howyouknowus: 'howyouknowus',
  user_id: 'user_id',
  gtagClientID: 'gtagClientID',
  gtagSessionID: 'gtagSessionID',
  pickupSurcharge: 'pickupSurcharge',
  pickupMOQSurcharge: 'pickupMOQSurcharge',
  greenShippingFee: 'greenShippingFee',
  greenShipping: 'greenShipping',
  ReviewButton: 'ReviewButton',
  isBeta: 'isBeta'
};

exports.Prisma.Prices_piecewise_baseScalarFieldEnum = {
  country_code: 'country_code',
  base: 'base'
};

exports.Prisma.Prices_piecewise_segmentsScalarFieldEnum = {
  id: 'id',
  country_code: 'country_code',
  breakpoint: 'breakpoint',
  gradient: 'gradient',
  order_index: 'order_index'
};

exports.Prisma.Rate_calculator_responsesScalarFieldEnum = {
  ID: 'ID',
  Date: 'Date',
  Name: 'Name',
  Contact: 'Contact',
  Destination: 'Destination',
  Weight: 'Weight',
  volumetric_weight: 'volumetric_weight',
  shipping_cost: 'shipping_cost',
  Length: 'Length',
  Height: 'Height',
  Width: 'Width',
  Pack: 'Pack',
  Fragile: 'Fragile',
  packing_cost: 'packing_cost',
  Insurance: 'Insurance',
  declared_value: 'declared_value',
  insurance_cost: 'insurance_cost',
  total_cost: 'total_cost',
  taxes: 'taxes',
  duties: 'duties',
  handling_fee: 'handling_fee'
};

exports.Prisma.RuralsurchargepostalcodesScalarFieldEnum = {
  countryCode: 'countryCode',
  postalCode: 'postalCode',
  postalCity: 'postalCity'
};

exports.Prisma.Shipping_comparison_durationScalarFieldEnum = {
  id: 'id',
  service: 'service',
  US: 'US',
  AU: 'AU',
  GB: 'GB',
  BE: 'BE',
  CA: 'CA',
  ES: 'ES',
  FR: 'FR',
  DE: 'DE',
  SE: 'SE',
  PT: 'PT',
  GR: 'GR',
  IT: 'IT',
  KR: 'KR',
  JP: 'JP',
  MY: 'MY',
  HK: 'HK',
  NZ: 'NZ',
  NL: 'NL',
  CN: 'CN'
};

exports.Prisma.Shipping_comparison_pricesScalarFieldEnum = {
  id: 'id',
  service: 'service',
  chargeable_weight: 'chargeable_weight',
  US: 'US',
  AU: 'AU',
  GB: 'GB',
  BE: 'BE',
  CA: 'CA',
  ES: 'ES',
  FR: 'FR',
  DE: 'DE',
  SE: 'SE',
  PT: 'PT',
  GR: 'GR',
  IT: 'IT',
  KR: 'KR',
  JP: 'JP',
  MY: 'MY',
  HK: 'HK',
  NZ: 'NZ',
  NL: 'NL',
  CN: 'CN'
};

exports.Prisma.TblfedexresponseScalarFieldEnum = {
  PkgID: 'PkgID',
  TrackingNo: 'TrackingNo',
  FedExResponseDateTime: 'FedExResponseDateTime',
  FedExDeliveryStatusTime: 'FedExDeliveryStatusTime',
  FedExDeliveryStatus: 'FedExDeliveryStatus'
};

exports.Prisma.TblfedexresponsedetailScalarFieldEnum = {
  ID: 'ID',
  PkgID: 'PkgID',
  TimeStamp: 'TimeStamp',
  EventType: 'EventType',
  EventDescription: 'EventDescription',
  StatusExceptionCode: 'StatusExceptionCode',
  StatusExceptionDescription: 'StatusExceptionDescription',
  City: 'City',
  StateOrProvinceCode: 'StateOrProvinceCode',
  PostalCode: 'PostalCode',
  CountryCode: 'CountryCode',
  CountryName: 'CountryName',
  Residential: 'Residential',
  ArrivalLocation: 'ArrivalLocation'
};

exports.Prisma.TblshipmentpaymentScalarFieldEnum = {
  paymentID: 'paymentID',
  shippingID: 'shippingID',
  transactionReference: 'transactionReference',
  paymentDate: 'paymentDate',
  paymentType: 'paymentType',
  paymentAmount: 'paymentAmount',
  surchargeAmount: 'surchargeAmount',
  paymentStatus: 'paymentStatus',
  remarks: 'remarks',
  isTopup: 'isTopup'
};

exports.Prisma.TbluserScalarFieldEnum = {
  userId: 'userId',
  userName: 'userName',
  password: 'password',
  userRoleId: 'userRoleId'
};

exports.Prisma.Unsubmitted_formsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  form_data: 'form_data',
  created_at: 'created_at',
  updated_at: 'updated_at',
  update_count: 'update_count',
  form_version: 'form_version'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  paymentMethod: 'paymentMethod',
  paymentType: 'paymentType',
  paymentAmount: 'paymentAmount',
  transactionReference: 'transactionReference',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentLineItemScalarFieldEnum = {
  id: 'id',
  paymentID: 'paymentID',
  referenceEntityType: 'referenceEntityType',
  referenceEntityID: 'referenceEntityID',
  description: 'description',
  amount: 'amount'
};

exports.Prisma.RefundsForReviewScalarFieldEnum = {
  id: 'id',
  paymentLineItemID: 'paymentLineItemID',
  refundAmount: 'refundAmount',
  remarks: 'remarks',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartnerShipmentScalarFieldEnum = {
  id: 'id',
  shippingID: 'shippingID',
  shippingProvider: 'shippingProvider',
  serviceType: 'serviceType',
  initialQuote: 'initialQuote',
  expectedQuote: 'expectedQuote',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TrackingInfoScalarFieldEnum = {
  id: 'id',
  packageID: 'packageID',
  shippingID: 'shippingID',
  status: 'status',
  shippingProvider: 'shippingProvider',
  trackingNumber: 'trackingNumber',
  fromLocationType: 'fromLocationType',
  toLocationType: 'toLocationType',
  destination: 'destination',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TrackingEventScalarFieldEnum = {
  id: 'id',
  trackingInfoID: 'trackingInfoID',
  status: 'status',
  payload: 'payload',
  createdAt: 'createdAt'
};

exports.Prisma.LabelScalarFieldEnum = {
  id: 'id',
  shippingID: 'shippingID',
  packageID: 'packageID',
  partner: 'partner',
  externalID: 'externalID',
  url: 'url',
  content: 'content',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.billing_invoice_status = exports.$Enums.billing_invoice_status = {
  Pending: 'Pending',
  Paid: 'Paid',
  Void: 'Void'
};

exports.billing_payment_records_paymentType = exports.$Enums.billing_payment_records_paymentType = {
  Invoice_Payment: 'Invoice_Payment',
  Refund: 'Refund',
  Credit_Wallet_Deposit: 'Credit_Wallet_Deposit',
  Credit_Wallet_Withdrawal: 'Credit_Wallet_Withdrawal'
};

exports.Prisma.ModelName = {
  Prompt: 'Prompt',
  CrispConversation: 'CrispConversation',
  CrispMessage: 'CrispMessage',
  ChatMessage: 'ChatMessage',
  Document: 'Document',
  UserActionLog: 'UserActionLog',
  CommodityDocument: 'CommodityDocument',
  CommodityCheckLog: 'CommodityCheckLog',
  Cache: 'Cache',
  ChatEvaluationQuestion: 'ChatEvaluationQuestion',
  ChatEvaluation: 'ChatEvaluation',
  ChatEvaluationRun: 'ChatEvaluationRun',
  ShopifyCustomApp: 'ShopifyCustomApp',
  ShopifySession: 'ShopifySession',
  ShopifyWebhook: 'ShopifyWebhook',
  ShopifyOrder: 'ShopifyOrder',
  EcommerceStore: 'EcommerceStore',
  EcommerceStoreSetting: 'EcommerceStoreSetting',
  EcommerceStoreSync: 'EcommerceStoreSync',
  EcommerceTaxNumber: 'EcommerceTaxNumber',
  DraftShipment: 'DraftShipment',
  BackgroundJob: 'BackgroundJob',
  FreightCostInvoice: 'FreightCostInvoice',
  DutiesTaxesCostInvoice: 'DutiesTaxesCostInvoice',
  WjQ_sfa_box_size: 'WjQ_sfa_box_size',
  WjQ_sfa_recipient_adress: 'WjQ_sfa_recipient_adress',
  WjQ_sfa_sender_adress: 'WjQ_sfa_sender_adress',
  WjQ_usermeta: 'WjQ_usermeta',
  WjQ_users: 'WjQ_users',
  preferential_rates: 'preferential_rates',
  user_segment_form_response: 'user_segment_form_response',
  user_tnc_acceptance: 'user_tnc_acceptance',
  billing_credit_note: 'billing_credit_note',
  billing_credit_note_line_item: 'billing_credit_note_line_item',
  billing_invoice: 'billing_invoice',
  billing_invoice_line_item: 'billing_invoice_line_item',
  billing_payment_records: 'billing_payment_records',
  cartitemdata: 'cartitemdata',
  cartparceldata: 'cartparceldata',
  cartrecipientdata: 'cartrecipientdata',
  cartsenderdata: 'cartsenderdata',
  crisp_whatsapp_business_callback_responses: 'crisp_whatsapp_business_callback_responses',
  crisp_whatsapp_business_requests: 'crisp_whatsapp_business_requests',
  daily_pickup_state: 'daily_pickup_state',
  disc_prices_orig_users_above_50kg_v2: 'disc_prices_orig_users_above_50kg_v2',
  disc_prices_orig_users_till_50kg_v2: 'disc_prices_orig_users_till_50kg_v2',
  discount_codes: 'discount_codes',
  fedex_ratecard_net_rates_20220915: 'fedex_ratecard_net_rates_20220915',
  fedex_ratecard_net_rates_20230510: 'fedex_ratecard_net_rates_20230510',
  fedex_ratecard_net_rates_20230905: 'fedex_ratecard_net_rates_20230905',
  fedex_ratecard_per_kg_20220915: 'fedex_ratecard_per_kg_20220915',
  fedex_ratecard_per_kg_20230510: 'fedex_ratecard_per_kg_20230510',
  fedex_ratecard_per_kg_20230905: 'fedex_ratecard_per_kg_20230905',
  fedex_zone_chart: 'fedex_zone_chart',
  formtblitemdata: 'formtblitemdata',
  formtblparceldata: 'formtblparceldata',
  formtblrecipientdata: 'formtblrecipientdata',
  formtblsenderdata: 'formtblsenderdata',
  prices_piecewise_base: 'prices_piecewise_base',
  prices_piecewise_segments: 'prices_piecewise_segments',
  rate_calculator_responses: 'rate_calculator_responses',
  ruralsurchargepostalcodes: 'ruralsurchargepostalcodes',
  shipping_comparison_duration: 'shipping_comparison_duration',
  shipping_comparison_prices: 'shipping_comparison_prices',
  tblfedexresponse: 'tblfedexresponse',
  tblfedexresponsedetail: 'tblfedexresponsedetail',
  tblshipmentpayment: 'tblshipmentpayment',
  tbluser: 'tbluser',
  unsubmitted_forms: 'unsubmitted_forms',
  Payment: 'Payment',
  PaymentLineItem: 'PaymentLineItem',
  RefundsForReview: 'RefundsForReview',
  PartnerShipment: 'PartnerShipment',
  TrackingInfo: 'TrackingInfo',
  TrackingEvent: 'TrackingEvent',
  Label: 'Label'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
